/*
 * CATALOG MANAGER
 */

/**
 * carica altri cataloghi
 */
// function loadOtherCatalogs(offset, limit, type, urlChain, search_string, options, replace) {
//
//     if(typeof replace == "undefined") { replace = false; }
//
//     if(replace) {
//         $("#article-set-wrapper").html("");
//     }
//
//     search_string = (typeof search_string != "undefined" ? search_string : null);
//     options.json_filters = ((typeof options == "undefined" || typeof options.json_filters == "undefined") ? "[]" : options.json_filters);
//     options.json_measures = ((typeof options == "undefined" || typeof options.json_measures == "undefined") ? "[]" : options.json_measures);
//     options.json_capacities = ((typeof options == "undefined" || typeof options.json_capacities == "undefined") ? "[]" : options.json_capacities);
//
//     if(type == "search") {
//         var params = new URLSearchParams({
//             "string": search_string,
//             "filters": options.json_filters,
//             "measures": options.json_measures,
//             "capacities": options.json_capacities,
//             "offset": offset
//         });
//         history.pushState(null, null, url__ecommerce_search+'?'+params.toString());
//     }
//
//     $("#article-set-wrapper").find("a.load-others").replaceWith('<img class="loading-img" src="/images/spinner_squares_circle.gif">');
//
//     var url = url__ecommerce_catalog_render_partial_products;
//
//     $.get(url, {
//         "offset": offset,
//         "limit": limit,
//         "type": type,
//         "urlChain": urlChain,
//         "string": search_string,
//         "filters": options.json_filters,
//         "measures": options.json_measures,
//         "capacities": options.json_capacities,
//         "time": Date.now()
//     }, function(html) {
//         $("#article-set-wrapper").find("img.loading-img").remove();
//         if(replace) {
//             $("#article-set-wrapper").html(html);
//         } else {
//             $("#article-set-wrapper").append(html);
//         }
//     }).fail(function () {
//         // location.reload();
//     });
// }

/* notifications */

function notifyAvailability(element, style, title, content, article_id) {

    Panda.Minipopup.open( {
        title: title,
        detail: content
    });

    // console.log('av');
    //
    // $(element).notify({
    //     title: title,
    //     content: content,
    //     footer: '<button type="button" class="button-default button-orange font-17 c-white" onclick="dismissAvailibilityNotificationPopover(' + article_id + ');">' +
    //                 '<span>'            +
    //                     'OK'            +
    //                 '</span>'           +
    //             '</button>'
    // }, {
    //     arrowShow: false,
    //     style: 'rgb-notification-availibility',
    //     className: style,
    //     autoHide: false,
    //     position: 'top',
    //     showAnimation: 'slideDown',
    //     showDuration: 400,
    //     hideAnimation: 'slideUp',
    //     hideDuration: 200
    // });
}

function notifyIncomingOrders(element, style, title, article_id) {

    // $(element).notify({
    //     title: title,
    //     content: '<div id="incoming-orders-wrapper-'+article_id+'"><img class="loader" src="/images/spinner_squares_circle.gif"></div><script>loadIncomingOrders("'+article_id+'");</script>',
    //     close: '<button type="button" onclick="dismissAvailibilityNotificationPopover(' + article_id + ');">' +
    //                 '<i class="fa fa-times font-20 c-white">'            +
    //                 '</i>'           +
    //             '</button>'
    // }, {
    //     arrowShow: false,
    //     style: 'rgb-notification-incoming-orders',
    //     className: style,
    //     autoHide: false,
    //     position: 'top',
    //     showAnimation: 'slideDown',
    //     showDuration: 400,
    //     hideAnimation: 'slideUp',
    //     hideDuration: 200,
    //     clickToHide: true
    // });
}

/* END notifications */

var render_incoming_orders_table_url = url__ecommerce_catalog_render_incoming_orders_table;

/**
 * recupera la tabella degli ordini in arrivo
 */
function loadIncomingOrders(article_id) {

    $.get(render_incoming_orders_table_url, {
        article_id: article_id,
        time: Date.now()
    }, function(html) {
        $(document).find("#incoming-orders-wrapper-"+article_id).html(html);
    }).fail(function () {
        location.reload();
    });
}

/**
 * incoming orders
 */
$(".js-incomingOrders").click(function () {

    Panda.popup( {
        items: {
            src: '#popup-incoming-orders-'+$(this).attr("data-id")
        },
        type: 'inline',
        tLoading: '',
        mainClass: '',
        callbacks: {
            beforeClose: function () {
                // if "do not show" is checked
                // $( '#hide-newsletter-popup' )[ 0 ].checked && Panda.setCookie( 'hideNewsletterPopup', true, 7 );
            }
        },
    } );
});